import { HighlightColor, Keyword } from '@tendium/prom-types';
import React, { FC } from 'react';
import KeywordsItemQuickFilter from './KeywordsItemQucikFilter';

interface KeywordsAreaProps {
  keywords: readonly Keyword[];
  removeKeyword: (id: string) => void;
}

export const KeywordsAreaQuickFilter: FC<KeywordsAreaProps> = props => {
  const { keywords, removeKeyword } = props;

  return (
    <>
      {!!keywords.length &&
        keywords.map((keyword: Keyword) => (
          <KeywordsItemQuickFilter
            keyword={keyword}
            key={keyword.value}
            removeKeyword={removeKeyword}
            color={keyword.highlightColor || HighlightColor.Yellow}
          />
        ))}
    </>
  );
};

export default KeywordsAreaQuickFilter;
